export default __webpack_public_path__ + "static/media/no-hay-tareas.2c422f13.png";